(function () {
  // Счётчики
  var counters = document.querySelectorAll('[data-count-to]');
  if ('IntersectionObserver' in window && counters.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.target.dataset.done) return;
        en.target.dataset.done = '1';
        var to = parseInt(en.target.dataset.countTo, 10);
        var fmt = en.target.dataset.countFormat;
        var t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 1600, 1);
          var val = Math.round(to * (1 - Math.pow(1 - p, 3)));
          en.target.textContent = fmt === 'space' ? val.toLocaleString('en-US').replace(/,/g, ' ') : (fmt === 'comma' ? val.toLocaleString('en-US') : val);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(en.target);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { io.observe(c); });
  }
  // Появление по скроллу
  var reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-revealed'); rio.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (r) { rio.observe(r); });
  }
  // Табы платформы
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.home-platform__tab');
    var panes = root.querySelectorAll('.home-platform__pane');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = parseInt(tab.dataset.tab, 10);
        tabs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        panes.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      });
    });
  });
})();

/* Корзина: добавление из витрины и карточки товара */
(function () {
  document.querySelectorAll('[data-ajax-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = e.submitter || form.querySelector('button');
      var buyNow = btn && btn.hasAttribute('data-buy-now');
      form.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: form.querySelector('[name=id]').value, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (buyNow) { window.location.href = '/checkout'; return null; }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('avokaid:added'));
        })
        .finally(function () { form.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); });
    });
  });
})();
